"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.OFFERS_LIST_FILTER_QUERY = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _commonCta = require("@mmc/common-cta");
var _text = require("@mmc/text");
var _commonLoader = require("@mmc/common-loader");
var _commonMediaQuery = require("@mmc/common-media-query");
var _commonErrorMessage = require("@mmc/common-error-message");
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _reactApollo = require("react-apollo");
var _commonRichText = require("@mmc/common-rich-text");
var _filters = require("./filters");
var _slider = require("./slider");
var _offerCard = _interopRequireDefault(require("./offer-card"));
var _offersList = require("./offers-list.prop-types");
var _commonLibs = require("@mmc/common-libs");
var _offersList2 = require("./offers-list.config");
var _offersList3 = require("./offers-list.utils");
require("./format-unicorn");
var _offersList4 = _interopRequireDefault(require("./offers-list.css"));
var _templateObject, _CommonLoader;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var OFFERS_LIST_FILTER_QUERY = (0, _graphqlTag["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2["default"])(["\n  query getOfferListByFilter(\n    $market: String!\n    $language: String!\n    $path: String!\n    $zipCode: [String]\n    $vehicles: [String]\n    $offerTypes: [String]\n    $modelYear: [String]\n    $datasetName: String\n  ) {\n    getOfferListByFilter(\n      market: $market\n      lang: $language\n      path: $path\n      zipCode: $zipCode\n      vehicle: $vehicles\n      offerType: $offerTypes\n      year: $modelYear\n      datasetName: $datasetName\n    ) {\n      offerLabel {\n        viewOfferCTA\n        seeAllVehicleOffers\n        viewHomePage\n        seeOffersLabel\n        seeOffersForVehiclesLabel\n        seeOffersNearZipCodeLabel\n        seeOffersForVehiclesNearZipCodeLabel\n      }\n      offerList {\n        vehicleName\n        vehicleCode\n        image\n        parentProductSkuId\n        isEnableProductStar\n        altText\n        allOffersLabel\n        legalTextForImageVehicle\n        showVLP\n        showActionButton\n        vehicleLandingpage\n        buildAndPriceUrl {\n          url\n          label\n          priority\n          icon\n        }\n        legalTextForImageDisclaimerData {\n          id\n          detail\n        }\n        offers {\n          offerCode\n          modelName\n          trimCode\n          trimName\n          offerImage\n          offerImageAltText\n          offerCode\n          offerType\n          offerTypeDisplayName\n          offerDisclaimerLabel\n          detailPageUrl\n          cardEyebrowText\n          legalTextImage\n          subHeadlineTextTwo\n          descriptions {\n            type\n            text\n          }\n          disclaimerData {\n            id\n            detail\n          }\n        }\n      }\n    }\n  }\n"])));
exports.OFFERS_LIST_FILTER_QUERY = OFFERS_LIST_FILTER_QUERY;
var hasOffers = function hasOffers(offers) {
  if (offers === void 0) {
    offers = [];
  }
  return offers.filter(function (vehicle) {
    return vehicle && vehicle.offers.length;
  }).length;
};
var isIE11 = false;
var isEdge = false;
if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (window.navigator) isEdge = window.navigator.userAgent.indexOf('Edge') > -1;
}
var safeScrollDocument = function safeScrollDocument(desiredPosition) {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    if (isIE11) {
      document.documentElement.scrollTop = desiredPosition;
    } else if (isEdge) {
      document.querySelector('body').scrollTop = desiredPosition;
    } else {
      window.scrollTo({
        top: desiredPosition,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
};
var OffersListV2 = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(OffersListV2, _React$PureComponent);
  OffersListV2.resourceType = function resourceType() {
    return 'OffersListV2_1_0_0';
  };
  function OffersListV2(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      viewMode: props.view || _offersList2.viewModesMap.SLIDER,
      slidersControlsMap: {},
      queryParams: {},
      queryVariables: {},
      skipQuery: true,
      showFeefo: false // will be enabled once Feefo is loaded
    };
    _this.containerClass = (0, _clsx["default"])(props.theme['col-xs-12'], props.theme['col-sm-offset-1'], props.theme['col-sm-10'], props.theme['col-md-offset-0'], props.theme['col-md-10']);
    _this.slidersRef = {};
    _this.handleFiltersChange = _this.handleFiltersChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.viewOffersByVehicleCode = _this.viewOffersByVehicleCode.bind((0, _assertThisInitialized2["default"])(_this));
    _this.createNextSlideHandler = _this.createNextSlideHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.createPrevSlideHandler = _this.createPrevSlideHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.observer = {};
    return _this;
  }
  var _proto = OffersListV2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    Object.keys(this.slidersRef).forEach(function (sliderIndex) {
      return _this2.setSliderControlsVisibility(sliderIndex, 0);
    });
    var router = this.props.router;
    this.setState({
      queryParams: router.location.query
    });
    var feefoDiv = document.getElementById('feefoDiv');

    /* override click event listener added by Feefo and prevent it from being executed */
    var overrideEventListener = function overrideEventListener(className) {
      setTimeout(function () {
        var elements = document.getElementsByClassName(className) || [];
        for (var _iterator = _createForOfIteratorHelperLoose(elements), _step; !(_step = _iterator()).done;) {
          var element = _step.value;
          element.addEventListener('click', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
          }, true);
        }
        _this2.setState({
          showFeefo: true
        });
      }, 700);
    };
    var handler = function handler(mutationList) {
      mutationList.map(function (mutation) {
        return mutation.addedNodes;
      }).filter(function (nodeList) {
        return nodeList.length;
      }).forEach(function (nodeList) {
        for (var _iterator2 = _createForOfIteratorHelperLoose(nodeList), _step2; !(_step2 = _iterator2()).done;) {
          var node = _step2.value;
          var classList = node.classList || [];
          /* For EN language Feefo click event listener is added to div tag with className='summary-rating' */
          if (classList.contains('summary-rating')) {
            overrideEventListener('summary-rating');
          }
          /* For FR language Feefo click event listener is added to anchor(a) tag with className='feefowidget-product-stars' */
          if (classList.contains('feefowidget-product-stars')) {
            overrideEventListener('feefowidget-product-stars');
          }
        }
      });
    };
    this.observer = new MutationObserver(handler);
    if (feefoDiv) {
      /* Observer observes childList changes to identify whether Feefo has loaded in the DOM */
      this.observer.observe(feefoDiv, {
        childList: true,
        subtree: true
      });
    }
    _commonLibs.EventEmitter.subscribe('locationChangeEvent', function (data) {
      var router = _this2.props.router;
      var urlQueryParams = router.location.query;
      var stateCode = data.stateCode;
      _this2.setState({
        queryParams: _objectSpread(_objectSpread({}, urlQueryParams), {}, {
          zipCode: stateCode
        })
      });
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (typeof this.observer.disconnect === 'function') {
      this.observer.disconnect();
    }
  };
  _proto.handleFiltersChange = function handleFiltersChange(filterKey, selectedFilters, filters) {
    this.setViewMode(selectedFilters);
    this.setFiltersInQuery(selectedFilters, filters, filterKey);
    this.setGraphQLVariables(selectedFilters, filters);
  };
  _proto.setViewMode = function setViewMode(selectedFilters) {
    var isGrid = Object.values((0, _offersList3.getSelectedFilterKeysMap)(selectedFilters[_offersList2.filtersMap.VEHICLE])).length === 1;
    var viewMode = isGrid ? _offersList2.viewModesMap.GRID : _offersList2.viewModesMap.SLIDER;
    this.setState({
      viewMode: viewMode
    });
  };
  _proto.setSliderControlsVisibility = function setSliderControlsVisibility(sliderIndex, nextSlide) {
    var innerSlider = this.slidersRef[sliderIndex].innerSlider;
    var slideCount = innerSlider.state.slideCount;
    var slidesToScroll = innerSlider.props.slidesToScroll;
    var isPrevVisible = nextSlide > 0 && nextSlide < slideCount && slidesToScroll >= 1;
    var isNextVisible = nextSlide + slidesToScroll < slideCount;
    this.setState(function (prevState) {
      var _objectSpread2;
      return {
        slidersControlsMap: _objectSpread(_objectSpread({}, prevState.slidersControlsMap), {}, (_objectSpread2 = {}, _objectSpread2[sliderIndex] = {
          prev: isPrevVisible,
          next: isNextVisible
        }, _objectSpread2))
      };
    });
  };
  _proto.setFiltersInQuery = function setFiltersInQuery(selectedFilters, filters, filterKey) {
    var router = this.props.router;
    var location = _objectSpread(_objectSpread({}, router.location), {}, {
      query: _objectSpread(_objectSpread({}, router.location.query), (0, _offersList3.selectedFiltersToQuery)(selectedFilters, filters, filterKey))
    });
    Object.keys(location.query).forEach(function (key) {
      if (location.query[key] === '') {
        delete location.query[key];
      }
    });
    router.push(location);
  };
  _proto.setGraphQLVariables = function setGraphQLVariables(selectedFilters, filters) {
    var _this$props = this.props,
      market = _this$props.market,
      language = _this$props.language,
      path = _this$props.path,
      router = _this$props.router;
    var offerQueryVariables = (0, _offersList3.convertQueryToGraphQLVariables)(router.location.query, filters);
    var queryVariables = _objectSpread({
      market: market,
      language: language,
      path: path
    }, offerQueryVariables);
    (0, _offersList3.setCachedOfferQueryVariables)(offerQueryVariables);
    this.setState({
      skipQuery: false,
      queryVariables: queryVariables
    });
  };
  _proto.getSliderSettings = function getSliderSettings(sliderIndex, dataProps) {
    var _this3 = this;
    var theme = this.props.theme;
    var mobileAgent = (0, _commonMediaQuery.isMobileAgent)();
    var getSliderControl = function getSliderControl(type) {
      return mobileAgent ? null : /*#__PURE__*/_react["default"].createElement(_slider.SliderControl, {
        theme: theme,
        type: type
      });
    };
    return _objectSpread(_objectSpread({}, _offersList2.sliderSettings), {}, {
      prevArrow: getSliderControl(_offersList2.sliderDirectionMap.PREV),
      nextArrow: getSliderControl(_offersList2.sliderDirectionMap.NEXT),
      appendDots: function appendDots(dots) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", null, " ", dots, " "));
      },
      customPaging: function customPaging(i) {
        var dataPropsWithNumber = _objectSpread(_objectSpread({}, dataProps), {}, {
          'data-analytics-slide-number': i
        });
        return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, dataPropsWithNumber, {
          type: "button"
        }), i);
      },
      beforeChange: function beforeChange(_, nextSlide) {
        return _this3.setSliderControlsVisibility(sliderIndex, nextSlide);
      }
    });
  };
  _proto.viewOffersByVehicleCode = function viewOffersByVehicleCode(vehicleCode) {
    var _this4 = this;
    return function () {
      var queryParams = _this4.state.queryParams;
      _this4.setState({
        queryParams: _objectSpread(_objectSpread({}, queryParams), {}, {
          vehicles: vehicleCode
        })
      }, function () {
        return setTimeout(function () {
          safeScrollDocument(0);
        });
      });
    };
  };
  _proto.createPrevSlideHandler = function createPrevSlideHandler(sliderIndex) {
    var _this5 = this;
    return function () {
      _this5.slidersRef[sliderIndex].slickPrev();
    };
  };
  _proto.createNextSlideHandler = function createNextSlideHandler(sliderIndex) {
    var _this6 = this;
    return function () {
      _this6.slidersRef[sliderIndex].slickNext();
    };
  };
  _proto.renderOffers = function renderOffers(offers) {
    var _this7 = this;
    var _this$state = this.state,
      viewMode = _this$state.viewMode,
      showFeefo = _this$state.showFeefo;
    var _this$props2 = this.props,
      theme = _this$props2.theme,
      _this$props2$data = _this$props2.data,
      offerLabel = _this$props2$data.offerLabel,
      offerFilter = _this$props2$data.offerFilter,
      router = _this$props2.router;
    if (window && window.localStorage && window.localStorage.getItem('offerClicked')) {
      var timeout = setTimeout(function () {
        var elem = null;
        if (router.location && router.location.query && 'vehicles' in router.location.query && router.location.query.vehicles.split(',').length === 1) {
          var offerCode = window.localStorage.getItem('offerClicked');
          elem = document.querySelector("[data-analytics-offer-code='" + offerCode + "']");
        } else {
          var offerCodeWithVehicle = window.localStorage.getItem('offerClicked');
          var _offerCode = offerCodeWithVehicle.split('|')[0];
          var vehicleName = offerCodeWithVehicle.split('|')[1];
          elem = document.querySelector("\n            [data-analytics-offer-code='" + _offerCode + "'][data-vehicle-name='" + vehicleName + "']\n          ");
        }
        if (elem) {
          elem.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
          clearTimeout(timeout);
          window.localStorage.removeItem('offerClicked');
        }
      }, 10);
    }
    if (viewMode === _offersList2.viewModesMap.SLIDER) {
      return offers.map(function (vehicle, index) {
        if (!vehicle.offers || !vehicle.offers.length) {
          return null;
        }
        var disclaimer = (0, _offersList3.getVehicleDisclaimer)(vehicle);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _offersList4["default"].vehicleOfferItem,
          key: vehicle.vehicleName
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _clsx["default"])(_this7.containerClass, _offersList4["default"].vehicleContainer)
        }, /*#__PURE__*/_react["default"].createElement("img", {
          className: _offersList4["default"].vehicle,
          src: vehicle.image,
          alt: vehicle.altText
        }), vehicle.legalTextForImageVehicle && vehicle.legalTextForImageDisclaimerData && /*#__PURE__*/_react["default"].createElement(_text.Text, {
          text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
            html: vehicle.legalTextForImageVehicle
          }),
          className: theme.bodyCopy + " " + _offersList4["default"].greyButton + " " + _offersList4["default"].descriptionSubText,
          disclaimerData: vehicle.legalTextForImageDisclaimerData
        }), disclaimer && /*#__PURE__*/_react["default"].createElement("p", {
          className: _offersList4["default"].vehicleModelDisclaimer
        }, disclaimer)), /*#__PURE__*/_react["default"].createElement("div", {
          className: (0, _clsx["default"])(_this7.containerClass, _offersList4["default"].offerTitleContainer)
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: (0, _clsx["default"])(_offersList4["default"].offerTitle)
        }, vehicle.vehicleName), vehicle.isEnableProductStar && showFeefo && /*#__PURE__*/_react["default"].createElement("div", {
          id: "feefoDiv",
          className: "feefo-product-stars-widget",
          "data-parent-product-sku": vehicle.parentProductSkuId
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _offersList4["default"].sliderContainer
        }, /*#__PURE__*/_react["default"].createElement(_slider.Slider, {
          forwardedRef: function forwardedRef(ref) {
            _this7.slidersRef[index] = ref;
          },
          className: (0, _clsx["default"])(_this7.containerClass, _offersList4["default"].slider),
          settings: _this7.getSliderSettings(index, {
            'data-analytics-vehicle-name': vehicle.vehicleName
          })
        }, vehicle.offers.map(function (offer) {
          return /*#__PURE__*/_react["default"].createElement(_offerCard["default"], {
            key: offer.offerCode,
            vehicleName: vehicle.vehicleName,
            className: (0, _clsx["default"])(_offersList4["default"].offerCard, _offersList4["default"].offerCardSlider),
            onDetailsClick: _this7.goToOfferDetails,
            theme: theme,
            offer: offer,
            labels: offerLabel
          });
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: _this7.containerClass + " " + _offersList4["default"].mobileContainer
        }, vehicle.showVLP && /*#__PURE__*/_react["default"].createElement("div", {
          className: "" + theme.mb5
        }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
          theme: theme,
          data: {
            priority: 'low',
            label: offerFilter.explorerLabel + ' ' + vehicle.vehicleName,
            url: vehicle.vehicleLandingpage
          },
          classes: [theme.mr5 + " " + theme.pb3]
        })), vehicle.showActionButton && /*#__PURE__*/_react["default"].createElement("div", {
          className: "" + theme.mb5
        }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
          theme: theme,
          data: {
            priority: 'low',
            label: vehicle.buildAndPriceUrl.label,
            url: vehicle.buildAndPriceUrl.url
          },
          classes: [theme.mr5 + " " + theme.pb3]
        }))));
      });
    }
    return offers.map(function (vehicle) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: vehicle.vehicleName
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-md-offset-1'], theme['col-md-10'])
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.row
      }, vehicle.offers.map(function (offer) {
        return /*#__PURE__*/_react["default"].createElement(_offerCard["default"], {
          key: offer.offerCode,
          className: (0, _clsx["default"])(_offersList4["default"].offerCard, _offersList4["default"].offerCardGrid, theme['col-xs-12'], theme['col-sm-6'], theme['col-md-4']),
          modelDisclaimer: (0, _offersList3.getVehicleDisclaimer)(vehicle),
          theme: theme,
          offer: offer,
          showImage: true,
          showLongDescription: true,
          labels: offerLabel
        });
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _this7.containerClass + " " + _offersList4["default"].mobileContainer
      }, vehicle.showVLP && /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + theme.mb5
      }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        theme: theme,
        data: {
          priority: 'low',
          label: offerFilter.explorerLabel + ' ' + vehicle.vehicleName,
          url: vehicle.vehicleLandingpage
        },
        classes: [theme.mr5 + " " + theme.pb3]
      })), vehicle.showActionButton && /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + theme.mb5
      }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
        theme: theme,
        data: {
          priority: 'low',
          label: vehicle.buildAndPriceUrl.label,
          url: vehicle.buildAndPriceUrl.url
        },
        classes: [theme.mr5 + " " + theme.pb3]
      }))));
    });
  };
  _proto.render = function render() {
    var _this8 = this;
    var _this$state2 = this.state,
      queryParams = _this$state2.queryParams,
      queryVariables = _this$state2.queryVariables,
      skipQuery = _this$state2.skipQuery;
    var _this$props3 = this.props,
      _this$props3$data = _this$props3.data,
      offerLabel = _this$props3$data.offerLabel,
      offerFilter = _this$props3$data.offerFilter,
      offerList = _this$props3$data.offerList,
      theme = _this$props3.theme,
      router = _this$props3.router,
      market = _this$props3.market;
    var filterOfferHeadingText = offerFilter.filterOfferHeadingText;

    // sort modelYear by descending
    if (Array.isArray(offerFilter.modelYear)) {
      offerFilter.modelYear = offerFilter.modelYear.sort(function (a, b) {
        return b.id - a.id;
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_filters.OffersFilter, {
      router: router,
      onChange: this.handleFiltersChange,
      theme: theme,
      data: offerFilter,
      market: market,
      queryParams: queryParams
    }), /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: OFFERS_LIST_FILTER_QUERY,
      variables: queryVariables,
      skip: skipQuery
    }, function (_ref) {
      var loading = _ref.loading,
        data = _ref.data,
        error = _ref.error;
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_commonErrorMessage.CommonErrorMessage, {
          theme: theme,
          errorTitle: offerFilter.errorTitle,
          errorContent: offerFilter.errorContent,
          viewHomePage: offerLabel.viewHomePage,
          viewHomePagePath: offerLabel.viewHomePagePath
        });
      }
      var offers = skipQuery ? offerList : data && data.getOfferListByFilter.offerList;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _offersList4["default"].OffersList
      }, loading || hasOffers(offers) ? /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _clsx["default"])(_offersList4["default"].pageTitle, _this8.containerClass)
      }, (0, _offersList3.getTitle)({
        data: data,
        queryVariables: queryVariables,
        defaultTitle: filterOfferHeadingText
      })) : /*#__PURE__*/_react["default"].createElement(_commonErrorMessage.CommonErrorMessage, {
        theme: theme,
        errorTitle: offerFilter.offerNotAvailableTitle,
        className: _offersList4["default"].noData
      }), loading ? _CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null)) : _this8.renderOffers(offers));
    }));
  };
  return OffersListV2;
}(_react["default"].PureComponent);
OffersListV2.displayName = 'OffersListV2';
OffersListV2.resourceType = function () {
  return 'OffersListV2_1_0_0';
};
var mapStateToProps = function mapStateToProps(state, props) {
  var _state$Config, _state$Config2, _state$Config3;
  return {
    market: props.market || ((_state$Config = state.Config) == null ? void 0 : _state$Config.market),
    language: props.language || ((_state$Config2 = state.Config) == null ? void 0 : _state$Config2.language),
    path: props.path || ((_state$Config3 = state.Config) == null ? void 0 : _state$Config3.path)
  };
};
var _default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(OffersListV2));
exports["default"] = _default;